import auth from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';
export const routes = [{
  name: 'menu.welcome',
  key: 'welcome',
  breadcrumb: false
}, // {
//   name: 'menu.dashboard',
//   key: 'dashboard',
//   children: [
//     {
//       name: 'menu.dashboard.workplace',
//       key: 'dashboard/workplace',
//     },
//     {
//       name: 'menu.dashboard.monitor',
//       key: 'dashboard/monitor',
//       requiredPermissions: [
//         { resource: 'menu.dashboard.monitor', actions: ['write'] },
//       ],
//     },
//   ],
// },
// {
//   name: 'menu.visualization',
//   key: 'visualization',
//   children: [
//     {
//       name: 'menu.visualization.dataAnalysis',
//       key: 'visualization/data-analysis',
//       requiredPermissions: [
//         { resource: 'menu.visualization.dataAnalysis', actions: ['read'] },
//       ],
//     },
//     {
//       name: 'menu.visualization.multiDimensionDataAnalysis',
//       key: 'visualization/multi-dimension-data-analysis',
//       requiredPermissions: [
//         {
//           resource: 'menu.visualization.dataAnalysis',
//           actions: ['read', 'write'],
//         },
//         {
//           resource: 'menu.visualization.multiDimensionDataAnalysis',
//           actions: ['write'],
//         },
//       ],
//       oneOfPerm: true,
//     },
//   ],
// },
// {
//   name: 'menu.list',
//   key: 'list',
//   children: [
//     {
//       name: 'menu.list.searchTable',
//       key: 'list/search-table',
//     },
//     {
//       name: 'menu.list.cardList',
//       key: 'list/card',
//     },
//   ],
// },
// {
//   name: 'menu.form',
//   key: 'form',
//   children: [
//     {
//       name: 'menu.form.group',
//       key: 'form/group',
//       requiredPermissions: [
//         { resource: 'menu.form.group', actions: ['read', 'write'] },
//       ],
//     },
//     {
//       name: 'menu.form.step',
//       key: 'form/step',
//       requiredPermissions: [
//         { resource: 'menu.form.step', actions: ['read'] },
//       ],
//     },
//   ],
// },
// {
//   name: 'menu.profile',
//   key: 'profile',
//   children: [
//     {
//       name: 'menu.profile.basic',
//       key: 'profile/basic',
//     },
//   ],
// },
//
// {
//   name: 'menu.result',
//   key: 'result',
//   children: [
//     {
//       name: 'menu.result.success',
//       key: 'result/success',
//       breadcrumb: false,
//     },
//     {
//       name: 'menu.result.error',
//       key: 'result/error',
//       breadcrumb: false,
//     },
//   ],
// },
// {
//   name: 'menu.exception',
//   key: 'exception',
//   children: [
//     {
//       name: 'menu.exception.403',
//       key: 'exception/403',
//     },
//     {
//       name: 'menu.exception.404',
//       key: 'exception/404',
//     },
//     {
//       name: 'menu.exception.500',
//       key: 'exception/500',
//     },
//   ],
// },
// {
//   name: 'menu.tenant',
//   key: 'tenant',
//   children: [
//     {
//       name: 'menu.tenant.create',
//       key: 'tenant/create',
//     },
//     {
//       name: 'menu.tenant.list',
//       key: 'tenant/list'
//     }
//   ]
// },
// {
//   name: 'menu.customer',
//   key: 'customer',
//   children: [
//     {
//       name: 'menu.customer.brand.create',
//       key: 'customer/brand/create',
//       ignore: true,
//     },
//     {
//       name: 'menu.customer.brand.list',
//       key: 'customer/brand/list',
//     },
//     {
//       name: 'menu.customer.brand.result',
//       key: 'customer/brand/result',
//       ignore: true,
//     },
//     {
//       name: 'menu.customer.store.list',
//       key: 'customer/store/list',
//     },
//     {
//       name: 'menu.customer.store.create',
//       key: 'customer/store/create',
//       ignore: true,
//     },
//     {
//       name: 'menu.customer.store.result',
//       key: 'customer/store/result',
//       ignore: true,
//     },
//     {
//       name: 'menu.customer.store.data-analysis',
//       key: 'customer/store/data-analysis',
//       ignore: true,
//     }
//   ],
// },
// {
//   name: 'menu.cards',
//   key: 'cards',
//   children: [
//     {
//       name: 'menu.cards.create',
//       key: 'cards/create',
//       ignore: true,
//     },
//     {
//       name: 'menu.cards.list',
//       key: 'cards/list',
//     },
//     {
//       name: 'menu.cards.result',
//       key: 'cards/result',
//       ignore: true,
//     },
//   ],
// },
// {
//   name: 'menu.material',
//   key: 'material',
//   children: [
//     {
//       name: 'menu.material.create',
//       key: 'material/create',
//       children: [
//         // {
//         //   name: 'menu.material.text.create',
//         //   key: 'material/create/text',
//         // },
//         // {
//         //   name: 'menu.material.audio.create',
//         //   key: 'material/create/audio',
//         // },
//         {
//           name: 'menu.material.create.video',
//           key: 'material/create/video',
//         },
//         // {
//         //   name: 'menu.material.create.image',
//         //   key: 'material/create/image',
//         // },
//         {
//           name: 'menu.material.create.result',
//           key: 'material/create/result',
//           ignore: true,
//         },
//       ],
//     },
//     {
//       name: 'menu.material.list',
//       key: 'material/list',
//     },
//   ],
// },
// {
//   name: 'menu.video-cut',
//   key: 'video-cut',
//   children: [
//     {
//       name: 'menu.video-cut.material',
//       key: 'video-cut/material',
//       children: [
//         {
//           name: 'menu.video-cut.material.video',
//           key: 'video-cut/material/video/list',
//         },
//         {
//           name: 'menu.video-cut.material.video.create',
//           key: 'video-cut/material/video/create',
//           ignore: true,
//         },
//         {
//           name: 'menu.video-cut.material.video.detail',
//           key: 'video-cut/material/video/detail',
//           ignore: true,
//         },
//         // {
//         //   name: 'menu.video-cut.material.image',
//         //   key: 'video-cut/material/image',
//         // },
//         {
//           name: 'menu.video-cut.material.audio',
//           key: 'video-cut/material/audio/list',
//         },
//         {
//           name: 'menu.video-cut.material.audio.create',
//           key: 'video-cut/material/audio/create',
//           ignore: true,
//         },
//       ]
//     },
//     // {
//     //   name: 'menu.video-cut.template',
//     //   key: 'video-cut/template',
//     //   children: [
//     //     {
//     //       name: 'menu.video-cut.template.list',
//     //       key: 'video-cut/template/list',
//     //     }
//     //   ]
//     // },
//     {
//       name: 'menu.video-cut.cut',
//       key: 'video-cut/cut',
//       children: [
//         {
//           name: 'menu.video-cut.cut.create',
//           key: 'video-cut/cut/create-batch',
//         },
//         {
//           name: 'menu.video-cut.cut.list',
//           key: 'video-cut/cut/list',
//         },
//         {
//           name: 'menu.video-cut.cut.detail',
//           key: 'video-cut/cut/detail',
//           ignore: true,
//         },
//         {
//           name: 'menu.video-cut.cut.audit',
//           key: 'video-cut/cut/audit',
//         },
//       ]
//     },
//     // {
//     //   name: 'menu.video-cut.template-cut',
//     //   key: 'video-cut/template-cut',
//     //   children: [
//     //       {
//     //         name: 'menu.video-cut.template-cut.create',
//     //         key: 'video-cut/template-cut/create',
//     //       },
//     //       {
//     //         name: 'menu.video-cut.template-cut.list',
//     //         key: 'video-cut/template-cut/list',
//     //       },
//     //       {
//     //         name: 'menu.video-cut.template-cut.detail',
//     //         key: 'video-cut/template-cut/detail',
//     //         ignore: true,
//     //       },
//     //       {
//     //         name: 'menu.video-cut.template-cut.audit',
//     //         key: 'video-cut/template-cut/audit',
//     //       },
//     //   ]
//     // },
//     {
//       name: 'menu.video-cut.result',
//       key: 'video-cut/result',
//       ignore: true,
//     },
//   ]
// },
// {
//   name: 'menu.weixin',
//   key: 'weixin',
//   children: [
//     {
//       name: 'menu.weixin.bind.list',
//       key: 'weixin/bind/list'
//     },
//   ]
// }
// {
//   name: 'menu.user',
//   key: 'user',
//   children: [
//     {
//       name: 'menu.user.info',
//       key: 'user/info',
//     },
//     {
//       name: 'menu.user.setting',
//       key: 'user/setting',
//     },
//   ],
// },
{
  name: "menu.business",
  key: "business",
  children: [{
    name: "menu.business.list",
    key: "business/list"
  }, {
    name: "menu.business.package.list",
    key: "business/package/list"
  }, {
    name: "menu.business.package.create",
    key: "business/package/create",
    ignore: true
  }]
}, {
  name: "menu.tenant",
  key: "tenant",
  children: [{
    name: "menu.tenant.list",
    key: "tenant/list"
  }, {
    name: "menu.tenant.create",
    key: "tenant/create",
    ignore: true
  }, {
    name: "menu.tenant.package.list",
    key: "tenant/package/list"
  }, {
    name: "menu.tenant.user.list",
    key: "tenant/user/list",
    ignore: true
  }]
}, {
  name: "menu.system",
  key: "system",
  children: [{
    name: "menu.system.menu",
    key: "system/menu"
  }, {
    name: "menu.system.user",
    key: "system/user"
  }, {
    name: "menu.system.role",
    key: "system/package"
  }, {
    name: "menu.system.permission",
    key: "system/permission"
  }, {
    name: "menu.system.dictionary",
    key: "system/dictionary"
  }]
}];
export const getName = (path, routes) => {
  return routes.find(item => {
    const itemPath = `/${item.key}`;

    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};
export const generatePermission = role => {
  const actions = role === 'admin' ? ['*'] : ['read'];
  const result = {};
  routes.forEach(item => {
    if (item.children) {
      item.children.forEach(child => {
        result[child.name] = actions;
      });
    }
  });
  return result;
};

const useRoute = userPermission => {
  const filterRoute = (routes, arr = []) => {
    if (!routes.length) {
      return [];
    }

    for (const route of routes) {
      const {
        requiredPermissions,
        oneOfPerm
      } = route;
      let visible = true;

      if (requiredPermissions) {
        visible = auth({
          requiredPermissions,
          oneOfPerm
        }, userPermission);
      }

      if (!visible) {
        continue;
      }

      if (route.children && route.children.length) {
        const newRoute = { ...route,
          children: []
        };
        filterRoute(route.children, newRoute.children);

        if (newRoute.children.length) {
          arr.push(newRoute);
        }
      } else {
        arr.push({ ...route
        });
      }
    }

    return arr;
  };

  const [permissionRoute, setPermissionRoute] = useState(routes);
  useEffect(() => {
    const newRoutes = filterRoute(routes);
    setPermissionRoute(newRoutes);
  }, [JSON.stringify(userPermission)]);
  const defaultRoute = useMemo(() => {
    const first = permissionRoute[0];

    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key;
      return firstRoute;
    }

    return '';
  }, [permissionRoute]);
  return [permissionRoute, defaultRoute];
};

export default useRoute;